import type {
  LHCDetailInvoiceRowData,
  SearchNomorMutasiRowData,
} from '../types';

const FALLBACK_VALUE = '-';

const toDisplayValue = (value: string | null | undefined): string =>
  value && value.trim().length > 0 ? value : FALLBACK_VALUE;

export const getVisibleLhcDetailRows = (
  rows: LHCDetailInvoiceRowData[],
  collapsedRows: Set<string>
): LHCDetailInvoiceRowData[] =>
  rows.flatMap((row) => {
    if (!row.isChildRow) {
      return [
        {
          ...row,
          isExpanded: row.hasChildren && !collapsedRows.has(row.rowId),
        },
      ];
    }

    return row.parentId && !collapsedRows.has(row.parentId) ? [row] : [];
  });

const resolveBankMutationEntryForRow = (
  row: LHCDetailInvoiceRowData,
  bankMutationId?: string | null
): LHCDetailInvoiceRowData['bankMutations'][number] | undefined => {
  const mutations = row.bankMutations;
  if (mutations.length === 0) {
    return undefined;
  }
  if (bankMutationId) {
    const match = mutations.find((m) => m.bankMutationId === bankMutationId);
    if (match) {
      return match;
    }
  }
  return mutations[0];
};

export const getMutationDetailRequestFromRow = (
  row: LHCDetailInvoiceRowData,
  bankMutationId?: string | null
): { mutationId: string; orderMetaId: string } | null => {
  const mutation = resolveBankMutationEntryForRow(row, bankMutationId);
  if (!mutation || !row.orderMetaId) {
    return null;
  }

  return {
    mutationId: mutation.bankMutationId,
    orderMetaId: row.orderMetaId,
  };
};

export const getSelectedMutationFromRow = (
  row: LHCDetailInvoiceRowData | null,
  bankMutationId?: string | null
): SearchNomorMutasiRowData | null => {
  if (!row) {
    return null;
  }

  const mutation = resolveBankMutationEntryForRow(row, bankMutationId);
  if (!mutation) {
    return null;
  }

  return {
    mutationId: mutation.bankMutationId,
    mutationNo: toDisplayValue(mutation.bankMutationNo),
    mutationDate: FALLBACK_VALUE,
    mutationValue: toDisplayValue(row.mutationValue),
    bank: toDisplayValue(row.bank),
    memoLine: FALLBACK_VALUE,
    remark: toDisplayValue(row.remark),
    remaining: FALLBACK_VALUE,
    remainingAmount: 0,
    isFullyUsed: false,
  };
};
